import { defineAsyncComponent } from "vue";

export { default as Input } from "./Input.vue";

export const Password = defineAsyncComponent(() => import("./Password.vue"));
export const MobileNumber = defineAsyncComponent(() => import("./MobileNumber.vue"));
